import React from 'react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import './OfflineIndicator.css';

/**
 * Component that displays a banner when the user is offline
 * Provides clear feedback about network connectivity status
 */
export default function OfflineIndicator() {
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div className="offline-indicator" role="alert" aria-live="assertive">
      <div className="offline-indicator-content">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM9 7C9 6.44772 9.44772 6 10 6C10.5523 6 11 6.44772 11 7V11C11 11.5523 10.5523 12 10 12C9.44772 12 9 11.5523 9 11V7ZM10 15C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15Z"
            fill="currentColor"
          />
        </svg>
        <span>
          <strong>You&apos;re offline.</strong> Some features may not be available. Changes will
          sync when you reconnect.
        </span>
      </div>
    </div>
  );
}
